import React, { useEffect } from "react"
import { cx, css } from "emotion"
import { Link, useHistory } from "react-router-dom"
import Button from "components/Button"
import Chip from "components/Chip"
import Img from "components/Img"
import { useAuth } from "providers/Auth"

const WINDOW_WIDTH = window.innerWidth

const mainInfo = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  text-align: center;
  position: relative;
  padding-left: 24px;
  padding-right: 24px;
`

const mobileRect = css`
  transform: rotate(-6deg);
  height: calc(100% + 30px);
`

const mobileRectBottom = css`
  transform: rotate(6deg);
`

const bgImage = css`
  height: 443px;
`

const text = css`
  max-width: 740px;
  font-size: 18px;
  z-index: 10;
`

const container = css`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;

  > * {
    max-width: 1920px;
  }
`
const bottomSection = css`
  min-height: 433px;
  @media (max-width: 959px) {
    min-height: unset;
  }
`

const separator = css`
  width: 560px;
  border-color: #e2e3e5;
  @media (max-width: 959px) {
    width: 80%;
  }
`
const contactCard = css`
  width: 262px;
  height: 152px;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #e2e3e5;
  background-color: #fff;
  padding: 30px;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  margin-bottom: 20px;
`

const tags1 = [
  { name: "Περιβάλλον", selected: true },
  { name: "Υγεία" },
  { name: "Εθνική Άμυνα" },
  { name: "Αγροτική Ανάπτυξη" }
]
const tags2 = [
  { name: "Εκπαίδευση", selected: true },
  { name: "Τουρισμός" },
  { name: "Υποδομές & Μεταφορές" },
  { name: "Αθλητισμός" }
]

const tags3 = [
  { name: "Ψηφιακος Μετασχηματισμός" },
  { name: "Ανάπτυξη" },
  { name: "Πολιτική Προστασία" }
]

const tags4 = [
  { name: "Υποτροφίες" },
  { name: "Πολιτισμός", selected: true },
  { name: "Προστασία του Πολίτη" }
]

const ContactCard = (props: { name: string; tel: string; mail: string }) => (
  <div className={contactCard}>
    <div className="flex ">
      <img className="mr-2.5" src="/images/user.svg" alt="user" />
      <span className="text-default text-default-600 font-semibold">
        {props.name}
      </span>
    </div>
    <div className="flex ">
      <img className="mr-2.5" src="/images/telephone.svg" alt="user" />
      <span className="text-default font-normal text-primary">{props.tel}</span>
    </div>
    <div className="flex ">
      <img className="mr-2.5" src="/images/email.svg" alt="user" />
      <span className="text-default font-normal text-secondary">
        {props.mail}
      </span>
    </div>
  </div>
)

function LandingPage() {
  const history = useHistory()
  const { cameFrom = "" } =
    (history.location.state as Record<string, string>) || {}
  const account = useAuth()
  useEffect(() => {
    if (account.auth.access_token && !account.auth.firstTime)
      history.push("/actions")
  }, [account])
  return (
    <div className={container}>
      <header className="z-10 h-16 py-3 pr-3.5 w-full bg-primary flex items-center justify-start">
        <Img className="h-16" src="/images/gov-logo.png" alt="logo" />
      </header>
      <main className="w-full flex flex-col items-center">
        <section className={mainInfo}>
          {WINDOW_WIDTH >= 960 && (
            <img
              className={cx(
                bgImage,
                "absolute z-0 w-full mobile:hidden -top-20 mobile:-top-5"
              )}
              src="/images/rectangle.svg"
              alt="message"
            />
          )}
          <div
            className={cx(
              mobileRect,
              "hidden mobile:block absolute w-230 bg-primary z-0 -top-12"
            )}
          />

          <span className="z-10 text-2xl font-bold mt-5 mobile:mt-6">
            Καλώς Ήρθατε στην Ψηφιακή Διαχείριση Δωρεών &amp; Χορηγιών
          </span>
          <span className={text}>
            Μία πλατφόρμα που προάγει τη διαφάνεια και την αποτελεσματική
            υλοποίηση δωρεών και χορηγιών με σκοπό τη μεγιστοποίηση του
            αντικτύπου τους.
          </span>
          <a
            className="z-10 mt-10 mobile:mt-6"
            href={"/api/v1/taxisnet/login-taxisnet"}>
            <Button
              className="flex items-center justify-center"
              type="secondary">
              Είσοδος στην Πλατφόρμα
            </Button>
          </a>
          <img
            className="z-10 mt-16 tablet-lg:mt-6 laptop-xs:mt-8 mobile:w-10 mobile:h-10 mobile:mt-7.5"
            src="/images/group-20.svg"
            alt="message"
          />
        </section>
        <span className="mt-10 text-1.5xl text-default text-default-600 text-center">
          Άμεση Πρόσβαση
        </span>
        <span className="text-primary mt-5 text-1.5xl text-center px-6">
          Αυθεντικοποίηση με κωδικούς taxisnet
        </span>
        <img
          loading="lazy"
          className="mt-7.5 px-5 mobile:mt-5"
          src="/images/login-card.svg"
          alt="message"
        />
        <div className="relative mt-7.5 w-full flex flex-col item-center">
          <span className={`z-10  mt-15 mobile:mt-7.5 text-1.5xl text-center`}>
            Εύκολη <b className="font-extrabold">Αναζήτηση</b> στις Δράσεις
            <br />
          </span>
        </div>
        <Img
          loading="lazy"
          className="z-10 mt-10 mb-0 mobile:mt-5 mobile:px-5"
          src="/images/group-13-new.png"
          alt="actions"
        />

        <span className="text-primary mt-15 mobile:mt-7.5 text-1.5xl text-center">
          <b className="font-extrabold">One-click</b> Εκδήλωση Ενδιαφέροντος
        </span>
        <img
          loading="lazy"
          className="mt-7.5 mobile:mt-5 mobile:px-5"
          src="/images/group-14.svg"
          alt="express interest"
        />
        <img
          loading="lazy"
          className="mt-20"
          src="/images/ministers-blue_2.svg"
          alt="express interest"
        />
        <hr className={separator} />
        <span className="text-primary mt-5 text-1.5xl text-center mobile:px-5">
          <b className="font-extrabold">Δείξτε</b> έμπρακτα το ενδιαφέρον σας σε
          οργανωμένες δράσεις για να αποκατασταθεί το φυσικό περιβάλλον, <br />{" "}
          να ενισχυθούν οι τοπικές κοινωνίες και να ξαναστηθούν οι ζωές των
          ανθρώπων.
        </span>
      </main>
      <section
        className={cx(
          bottomSection,
          "mt-13 mobile:mt-7 mobile:h-full flex flex-grow flex-col justify-end items-center w-full relative"
        )}>
        {WINDOW_WIDTH >= 960 && (
          <img
            loading="lazy"
            className={cx(bgImage, "mobile:hidden z-0 absolute w-full ")}
            src="/images/rectangle-bottom.svg"
            alt="rectangle bottom"
          />
        )}

        <div
          className={cx(
            "hidden mobile:inline-block absolute w-230 h-full z-0 overflow-y-hidden pt-6 mobile-lg:pt-8 tablet-xs:pt-9.5 tablet-sm:pt-11 tablet-md:pt-12"
          )}>
          <div className={cx(mobileRectBottom, "w-full h-full bg-primary")} />
        </div>

        <div className="w-full h-50 bg-primary absolute bottom-0 hidden mobile:inline-block"></div>

        <img
          loading="lazy"
          className="z-10 laptop-md:mb-6 laptop-lg:mb-5 laptop-xl:mb-10 screen-sm:mb-12 mobile:w-10 mobile:h-10 mobile-lg:mt-2 tablet-xs:mt-4 tablet-sm:mt-5 tablet-md:mt-7"
          src="/images/group-20.svg"
          alt="message"
        />
        <p className="z-10 mt-10 px-5 text-white text-center">
          Η πλατφόρμα <b>Ψηφιακής Διαχείρισης Δωρεών</b> για την αποκατάσταση
          των πυρόπληκτων περιοχών <br /> είναι διαθέσιμη προς κοινωφελή
          ιδρύματα, εταιρίες και άλλα νομικά πρόσωπα καθώς και προς ιδιώτες που
          θέλουν να συμμετέχουν και να προσφέρουν στις δράσεις αποκατάστασης.
        </p>
        <a
          className="z-10 mt-10 mobile:mt-6"
          href={"/api/v1/taxisnet/login-taxisnet"}>
          <Button className="flex items-center justify-center" type="secondary">
            Είσοδος στην Πλατφόρμα
          </Button>
        </a>

        <footer className="mt-10 z-10 w-full bg-default-100 py-1.5 px-7.5 mobile:px-5 flex items-center justify-between">
          <div className="flex items-center w-1/3 mobile:w-3/4">
            <Img
              loading="lazy"
              className="mobile:w-22.5"
              src="/images/gov-site.png"
              alt="gov-site"
            />
            <img
              loading="lazy"
              className="h-12 mobile:h-6"
              src="/images/ggps_logo.png"
              alt="ggps-logo"
            />
          </div>
          <a
            className="text-primary font-semibold mobile:text-3xs w-1/3 "
            href="https://www.gov.gr/info/oroi-xrisis"
            target="_blank">
            Όροι χρήσης
          </a>
          <span className="mobile:text-3xs">&copy; Copyright 2020 </span>
        </footer>
      </section>
    </div>
  )
}

export default LandingPage
